import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { api } from '../api/client'

export function RequireAuth({ audience, children }: { audience: 'admin' | 'user'; children: ReactNode }) {
  const location = useLocation()
  if (!api.canAccess(audience)) return <Navigate to={`/${audience}/login`} replace state={{ from: location.pathname }} />
  return <>{children}</>
}
